import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import {Login} from '../../services/user.service';
import {ActivatedRoute, Router } from '@angular/router';
import {CookieService} from 'ng2-cookies';

@Component({
host: {
      '(document:keydown)': 'keyDown($event)',
      },

  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})

export class AccountComponent implements OnInit {
public hex = require("../../../assets/hex.jpg");
 theUser: string;
 femail: string;
  searchText: string;

  constructor(private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router, private loginInfo: Login, private _cookieService:CookieService){
  }

  ngOnInit() {
     this.theUser = this.userSVC.authUser.email;
     if (!this.theUser) {
       this.router.navigate(['']);
     }

    this.activatedRoute.queryParams.subscribe(params => {
        this.searchText = params['q'] || "";
      });
   }
  
  validateEmail(email) {
     const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
     return re.test(email);
  }
  
  invite() {
      this.router.navigate(['/admin/invite'],  { queryParams: { q : this.searchText}});
    }

  tel() {
      this.router.navigate(['/admin/tel'],  { queryParams: { q : this.searchText}});
    }

  done() {
      this.router.navigate(['/admin/account'],  { queryParams: { q : this.searchText}});
    }

     keyDown(event: any) {
      switch (event.keyCode) {
        case 13:
        this.invite()
          event.preventDefault();
          break;
      }
      return;
    }

  resetPwd() {
      this.router.navigate(['/admin/reset'],  { queryParams: { q : this.searchText}});
    }

    setCookie(key: string, value: string){
      return this._cookieService.set(key, value);
    }
   getCookie(key: string){
      return this._cookieService.get(key);
    }

     logout(){
      if(!confirm("Do you want to Sign Out from Siloq®?")) {
        return;
      }
       let gwt = this.getCookie("gwt");
       this.setCookie("gwt", "");
       this.userSVC.logoutGwt(gwt);
       this.router.navigate(['']);
     }
 }



// WEBPACK FOOTER //
// ./src/app/admin/account/account.component.ts